import React from 'react'
import img1 from '../../../assets/images/modals/modal1.png'
import img2 from '../../../assets/images/modals/modal2.png'
import img3 from '../../../assets/images/modals/modal3.png'
import img4 from '../../../assets/images/modals/modal4.png'
import img5 from '../../../assets/images/modals/modal5.png'
import Show from '../../../utils/show'

const LOCALE =
  ['es-AR', 'es-CL', 'es-PE', 'es-PY', 'es-UY'].indexOf(process.env.LOCALE) > -1
    ? process.env.LOCALE
    : 'default'

const italatam = LOCALE === 'es-AR' || LOCALE === 'es-PY' || LOCALE === 'es-UY'

export const infoModal = [
  {
    txt: (
      <>
        <span>¿Sabías que?</span>
        <p>
          <Show valid={!italatam}>
            Debes cambiar tus protectores 3 veces al día para mantener limpia y
            fresca tu Zona V. <b>¡No lo olvides!</b>
          </Show>
          <Show valid={italatam}>
            Debés cambiar tus protectores 3 veces al día para mantener limpia y
            fresca tu Zona V. <b>¡No lo olvidés!</b>
          </Show>
        </p>
      </>
    ),
    img: img1,
    clase: '--modal1',
  },
  {
    txt: (
      <>
        <span>La Zona V</span>
        <p>
        <Show valid={!italatam}>
            en cada una de nosotras es diferente y única.
            <br />
            <br />
            <b>¡Siéntete orgullosa del poder de tu zona íntima!</b>
          </Show>
          <Show valid={italatam}>
            en cada una de nosotras es diferente y única.
            <br />
            <br />
            <b>¡Sentíte orgullosa del poder de tu zona íntima!</b>
          </Show>
        </p>
      </>
    ),
    img: img2,
    clase: '--modal2',
  },
  {
    txt: (
      <>
        <span>¡Viva la vulva!</span>
        <p>
          Vivamos libres de tabúes y el mito de la vulva perfecta.
          <br />
          <br />
          No nos avergoncemos de nuestros genitales.
        </p>
      </>
    ),
    img: img3,
    clase: '--modal3',
  },
  {
    txt: (
      <>
        <Show valid={!italatam}>
          <p>
            Entre ciclos, hormonas, dolor y placer, a veces sentimos que nuestro
            cuerpo se sale de control.
            <br />
            <br />
            Vive sin miedo, sé libre.
          </p>
          <span>¡Disfruta de ser mujer!</span>
        </Show>
        <Show valid={italatam}>
          <p>
            Entre ciclos, hormonas, dolor y placer, a veces sentimos que nuestro
            cuerpo se sale de control.
            <br />
            <br />
            Viví sin miedo, sé libre.
          </p>
          <span>¡Disfrutá de ser mujer!</span>
        </Show>
      </>
    ),
    img: img4,
    clase: '--modal4',
  },
  {
    txt: (
      <>
        <span>¡Sí!</span>
        <br />
        <span>La menstruación es normal</span>
        <p>
          y mostrarla también debería serlo. Desde ahora,{' '}
          <b>el rojo no nos sonroja.</b>
        </p>
      </>
    ),
    img: img5,
    clase: '--modal5',
  },
]
